/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';
import { IRevisionObject } from '../revision';
import RevisionDescriptor, { IRevisionJSON, IRevision } from '../descriptors/revisiondescriptor';

export interface IRevisionHistoryGetRevisionResponseJSON extends IRevisionJSON, IMessage {}

export default class RevisionHistoryGetRevisionResponse extends Message implements IRevision {
	public static readonly DESCRIPTOR_NAME: string = 'RevisionHistoryGetRevisionResponse';

	public static readonly DESCRIPTOR: IDescriptorBody = /* #__PURE__ -- @preserve */ ( () => RevisionDescriptor.DESCRIPTOR )();

	public constructor(
		public readonly revisionId: string,
		public readonly name?: string,
		public readonly creatorId?: string,
		public readonly authorsIds?: string[],
		public readonly createdAt?: Date,
		public readonly diffData?: string,
		public readonly attributes?: Record<string, unknown>,
		public readonly fromVersion?: number,
		public readonly toVersion?: number,
		public readonly isEmptyCurrent?: boolean
	) {
		super();
	}

	public toJSON(): IRevisionHistoryGetRevisionResponseJSON {
		return RevisionDescriptor.toJSON( this );
	}

	/**
	 * Creates frontend revision model from message sent from the backend.
	 *
	 * This method is intended to be used on the frontend side after receiving the response from the backend.
	 */
	public toObject(): IRevisionObject {
		return RevisionDescriptor.toObject( this );
	}

	public static create( params: IRevision ): RevisionHistoryGetRevisionResponse {
		return new RevisionHistoryGetRevisionResponse(
			params.revisionId,
			params.name,
			params.creatorId,
			params.authorsIds,
			params.createdAt,
			params.diffData,
			params.attributes,
			params.fromVersion,
			params.toVersion,
			params.isEmptyCurrent
		);
	}

	public static fromJSON( json: IRevisionHistoryGetRevisionResponseJSON ): RevisionHistoryGetRevisionResponse {
		return new RevisionHistoryGetRevisionResponse(
			json.revisionId,
			json.name,
			json.creatorId,
			json.authorsIds ? JSON.parse( json.authorsIds ) : undefined,
			json.createdAt ? new Date( json.createdAt ) : undefined,
			json.diffData,
			json.attributes ? JSON.parse( json.attributes ) : undefined,
			json.fromVersion,
			json.toVersion,
			json.isEmptyCurrent
		);
	}
}

